import { metricValue, type FleetMetricEnvelope } from "../../../api/mcp";
import { Bars } from "../../../components/charts";
import { ResourceView } from "../../../components/states";
import { Card, Notice } from "../../../components/ui";
import type { Resource } from "../../../hooks/useResource";
import { ProductTag } from "../../../products/PerProduct";

/** How many tools on each tier have their own row, rather than inheriting `*`. */
export function QuotaOverridesByTier({
  state,
  onRetry,
}: {
  state: Resource<FleetMetricEnvelope<"quota_overrides_count">>;
  onRetry: () => void;
}) {
  const byTier = metricValue(state);
  const tiers = byTier ? Object.keys(byTier).sort() : [];

  return (
    <Card
      title="Cap overrides by tier"
      note="Tools with their own row, not inheriting the tier's * default"
      aside={<ProductTag id="mcp" />}
    >
      <ResourceView state={state} what="cap overrides" onRetry={onRetry}>
        {() =>
          byTier && tiers.length > 0 ? (
            <Bars
              rows={tiers.map((t) => ({
                label: t,
                value: byTier[t] ?? 0,
                note: "own rows",
                tone: "brand" as const,
              }))}
              max={Math.max(...tiers.map((t) => byTier[t] ?? 0), 1)}
            />
          ) : (
            <Notice title="No overrides">Every tier resolves entirely through its * default.</Notice>
          )
        }
      </ResourceView>
    </Card>
  );
}
